/* eslint-disable */
export default {
  tollFree: '免付費電話',
  rcvPmiMeetingTitle: '{extensionName} 的視訊會議',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
